<template>
<div class="card">
    <div class="card-header pb-0">
        <h6>Kary</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
                <thead>
                    <tr>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Użytkownik</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Administrator</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Powód</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Data</th>
                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Wygasa</th>
                    </tr>
                </thead>
                <tbody>
                    <Kara user="MrPieselusYT" administrator="_99ms" reason="Griefing" date="15/05/2022" expire="16/05/2022" />
                    <Kara user="Notch" administrator="_99ms" reason="Griefing" date="15/05/2022" expire="16/05/2022" />
                    <Kara user="_99ms" administrator="_99ms" reason="Griefing" date="15/05/2022" expire="16/05/2022" />
                    <Kara user="Peseu251" administrator="_99ms" reason="Griefing" date="15/05/2022" expire="16/05/2022" />
                    <Kara user="Xzir3n_" administrator="_99ms" reason="Griefing" date="15/05/2022" expire="16/05/2022" />

                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import Kara from "./Kara.vue";
export default {
    name: "authors-table",
    components: { Kara }
};
</script>
